import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-2">Popular</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-foreground-900">Categories</h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md">
            Browse our complete collection of <strong>AllChinaBuy spreadsheet</strong> categories. Every category links directly to verified product listings.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`AllChinaBuy Spreadsheet ${cat.name} category`}
                  title={`AllChinaBuy Spreadsheet – ${cat.name} finds`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-3">
                  {cat.name}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  Best {cat.name} Spreadsheet Finds
                </h3>
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-600 font-medium">
                  <span>Browse Now</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}